const useRoofToggleHandler = (getValues, update) => {
  return (index, shouldMark) => {
    const currentValues = getValues("floorPlans");
    let updatedFields = [...currentValues];

    let isRoof = shouldMark ? 1 : 0;
    updatedFields = updatedFields.map((item, idx, arr) => {
      const newItem = { ...item };
      const label = `Floor ${arr.length - isRoof - idx}`;
      if (idx !== index) {
        if (newItem.isRoof) {
          newItem.isRoof = false;
        }

        if (!newItem.isLabelCustom) {
          newItem.label = label;
        }
      } else {
        newItem.isRoof = shouldMark;
        isRoof = 0;
        if (!newItem.isLabelCustom) {
          newItem.label = shouldMark ? `Roof` : label;
        }
      }

      return newItem;
    });

    // Push updated data to form state
    updatedFields.forEach((item, idx) => update(idx, item));
  };
};

export default useRoofToggleHandler;
